/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Login
 */
export interface Login {
  /**
   *
   * @type {string}
   * @memberof Login
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof Login
   */
  next?: string;
}

/**
 * Check if a given object implements the Login interface.
 */
export function instanceOfLogin(value: object): value is Login {
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function LoginFromJSON(json: any): Login {
  return LoginFromJSONTyped(json, false);
}

export function LoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): Login {
  if (json == null) {
    return json;
  }
  return {
    email: json["email"],
    next: json["next"] == null ? undefined : json["next"],
  };
}

export function LoginToJSON(json: any): Login {
  return LoginToJSONTyped(json, false);
}

export function LoginToJSONTyped(value?: Login | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    email: value["email"],
    next: value["next"],
  };
}
